<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link :to="{name: 'Create Thirteen Month Pay'}" class="button is-small is-info">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create (single)</router-link>
        &nbsp;
        <router-link :to="{name: 'Create Bulk 13th Month Pay'}" class="button is-small is-info">
          <span class="icon">
            <i class="fas fa-plus"></i>
          </span>&nbsp; Create (bulk payroll)</router-link>
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
        &nbsp;
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <b-select size="is-small" v-model="year" title="Year">
          <option value="0">All</option>
          <option value="2019">2019</option>
          <option value="2020">2020</option>
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
          <option value="2028">2028</option>
          <option value="2029">2029</option>
        </b-select>
        &nbsp;
        <button :class="buttonDownloadReportPeriodPdf" @click="downloadReport">Download Report</button>
      </div>
      <div class="level-right"></div>
    </div>
    <table-pagination :tableData="thirteenMonthPays.data" :bordered="true" :striped="true" :narrowed="true" :hoverable="true" :mobileCards="true" :loading="isLoadingTable" :page="page" :perPage="perPage" :totalData="thirteenMonthPays.totalData" @onPageChanged="page = $event" @onSearchChanged="search = $event" @onPerPageChanged="perPage = $event">
      <template slot="row-content" slot-scope="{item}">
        <b-table-column field="thirteenMonthPayId" class="table-column-content-is-small" label="ID">
          {{item.row.thirteenMonthPayId}}
        </b-table-column>
        <b-table-column field="employee" class="table-column-content-is-small" label="Employee">
          {{item.row.employee}}
        </b-table-column>
        <b-table-column field="amount" class="table-column-content-is-small" label="Total months">
          {{item.row.monthWorked}}
        </b-table-column>
        <b-table-column field="amount" class="table-column-content-is-small" label="Amount">
          {{item.row.amount}}
        </b-table-column>
        <b-table-column field="year" class="table-column-content-is-small" label="Year">
          {{item.row.year}}
        </b-table-column>
        <b-table-column field="dateCreated" class="table-column-content-is-small" label="Date created">
          {{item.row.dateCreated}}
        </b-table-column>
        <b-table-column field="" class="table-column-content-is-small" label="">
          <router-link :to="{name: 'Edit Thirteen Month Pay', params: {'thirteenMonthPayId': item.row.thirteenMonthPayId}}" class="button is-warning is-small">Edit</router-link>
          &nbsp;
          <button class="button is-danger is-small" @click="deleteThirteenMonthPay(item.row.thirteenMonthPayId)">Delete</button>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </table-pagination>
    <delete-modal/>
  </div>
</template>

<script>
import TablePagination from '../TablePagination.vue'
import { mapState, mapActions } from 'vuex'
import DeleteModal from './Delete.vue'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import axios from 'axios'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    page: 1,
    perPage: 10,
    search: '',
    year: 0,
    buttonDownloadReportPeriodPdf: appButton.isLoadingNormal(false)
  }),
  computed: {
    ...mapState('thirteenmonthpay', {
      isLoadingTable: state => state.isLoadingTable,
      thirteenMonthPays: state => state.thirteenMonthPays,
      showDeleteModal: state => state.showDeleteModal
    })
  },
  components: {
    tablePagination: TablePagination,
    deleteModal: DeleteModal
  },
  mounted() {
    this.default()
  },
  methods: {
    ...mapActions('thirteenmonthpay', [
      'getPaginatedThirteenMonthPays',
      'openDeleteModal'
    ]),
    default() {
      this.getPaginatedThirteenMonthPays({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        year: this.year
      })
    },
    refreshTable() {
      this.default()
    },
    deleteThirteenMonthPay(thirteenMonthPayId) {
      this.openDeleteModal({
        showDeleteModal: true,
        thirteenMonthPay: {
          thirteenMonthPayId: thirteenMonthPayId
        }
      })
    },
    downloadReport() {
      this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(true)
      axios
        .get(`downloadables/thirteenmonthpayreportbyyear?year=${this.year}`, {
          responseType: 'blob'
        })
        .then(response => {
          const yearValue = this.year === 0 ? 'All' : this.year

          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `13th Month Pay Report (${yearValue}).pdf`
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDownloadReportPeriodPdf = appButton.isLoadingNormal(false)
        })
    }
  },
  watch: {
    perPage(val) {
      this.getPaginatedThirteenMonthPays({
        page: this.page,
        pageSize: val,
        query: this.search,
        year: this.year
      })
    },
    page(val) {
      this.getPaginatedThirteenMonthPays({
        page: val,
        pageSize: this.perPage,
        query: this.search,
        year: this.year
      })
    },
    search(val) {
      this.getPaginatedThirteenMonthPays({
        page: this.page,
        pageSize: this.perPage,
        query: val,
        year: this.year
      })
    },
    year(val) {
      this.getPaginatedThirteenMonthPays({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
        year: val
      })
    },
    showDeleteModal() {
      this.default()
    }
  }
}
</script>

